import { Checkbox, TodoMark } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'
import type { DueState } from '../utils/due-date'
import { TODO_MARK } from '../../cells/surface'

export type ReminderMark = 'checkbox' | 'todo'

/**
 * Leading complete/uncomplete control. Shares its hit target with the
 * reminder's editable text (generous padded hit area via `after:`, matching the
 * HistorySelectCheckbox convention) rather than being a tiny isolated target
 * next to the label it controls.
 *
 * `todo` draws the To-dos section's mark, so a reminder matches the For You
 * rows beside it, toned by `due`.
 */
export function ReminderCheckbox({
  checked,
  title,
  mark = 'checkbox',
  due,
  onCheckedChange,
}: {
  checked: boolean
  title: string
  mark?: ReminderMark
  due?: DueState
  onCheckedChange: (checked: boolean) => void
}) {
  const label = checked ? `Mark "${title}" as unresolved` : `Mark "${title}" as resolved`

  if (mark === 'todo') {
    return (
      <TodoMark
        checked={checked}
        due={due}
        onChange={(event) => onCheckedChange(event.currentTarget.checked)}
        onClick={(e) => e.stopPropagation()}
        aria-label={label}
        className={`mt-[3px] ${TODO_MARK}`}
      />
    )
  }

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={onCheckedChange}
      onClick={(e) => e.stopPropagation()}
      aria-label={label}
      className={twMerge('relative', "after:absolute after:-inset-2 after:content-['']")}
    >
      <Checkbox.Indicator />
    </Checkbox>
  )
}
